// Tile cosmetic catalog. Per-tier name, colour palette, and (optionally)
// a bundled image. To set custom artwork: drop a PNG into `./tiles/<value>.png`
// (e.g. `./tiles/2.png`, `./tiles/4.png`). Webpack's require.context picks
// them up on next build. Tiles without an image render the gradient design.

export const TILES = {
  2:    { name: "Hand",        bg: "linear-gradient(135deg,#3a2d52,#2a1f3d)", fg: "#d8d4ec", glow: "rgba(168,105,255,0.0)" },
  4:    { name: "Skull",       bg: "linear-gradient(135deg,#4a3a6a,#332650)", fg: "#e8e4ff", glow: "rgba(168,105,255,0.15)" },
  8:    { name: "Shambler",    bg: "linear-gradient(135deg,#5d4585,#3d2a66)", fg: "#fff",     glow: "rgba(168,105,255,0.25)" },
  16:   { name: "Zombie",      bg: "linear-gradient(135deg,#7a5bb2,#4a2f88)", fg: "#fff",     glow: "rgba(168,105,255,0.35)" },
  32:   { name: "Ghoul",       bg: "linear-gradient(135deg,#a569ff,#6b3dc7)", fg: "#fff",     glow: "rgba(168,105,255,0.5)" },
  64:   { name: "Mummy",       bg: "linear-gradient(135deg,#c8a060,#8a6420)", fg: "#fff",     glow: "rgba(255,180,80,0.6)" },
  128:  { name: "Vampire",     bg: "linear-gradient(135deg,#ff5b6b,#8c0d20)", fg: "#fff",     glow: "rgba(255,91,107,0.6)" },
  256:  { name: "Wight",       bg: "linear-gradient(135deg,#5ee8ff,#1a8eae)", fg: "#0a1820",  glow: "rgba(94,232,255,0.6)" },
  512:  { name: "Lich",        bg: "linear-gradient(135deg,#7ed957,#3a8a1f)", fg: "#0a1820",  glow: "rgba(126,217,87,0.65)" },
  1024: { name: "Wraith",      bg: "linear-gradient(135deg,#c2ff5d,#7ed957)", fg: "#0a1820",  glow: "rgba(194,255,93,0.75)" },
  2048: { name: "Zombie King", bg: "linear-gradient(135deg,#ffd06b,#ff8b3d)", fg: "#1a0828",  glow: "rgba(255,208,107,0.85)" },
  4096: { name: "Eldritch",    bg: "linear-gradient(135deg,#ff3eaa,#7a1252)", fg: "#fff",     glow: "rgba(255,62,170,0.9)" },
  8192: { name: "Apex",        bg: "linear-gradient(135deg,#fff,#7ed957)",    fg: "#1a0828",  glow: "rgba(255,255,255,1)" },
};

// Auto-discover any tile artwork the user has dropped into ./tiles/<value>.png.
// require.context is evaluated at build time; webpack tracks all matching
// files and re-bundles on rebuild as more are added.
const IMG_MAP = (() => {
  const map = {};
  try {
    const ctx = require.context("./tiles", false, /\d+\.(png|webp|jpg|jpeg)$/);
    ctx.keys().forEach((key) => {
      const m = key.match(/(\d+)\.(png|webp|jpg|jpeg)$/i);
      if (!m) return;
      const value = parseInt(m[1], 10);
      const mod = ctx(key);
      map[value] = mod && mod.default ? mod.default : mod;
    });
  } catch (_e) {
    // No tiles folder yet — fall back to gradient art.
  }
  return map;
})();

export function tileImage(value) {
  return IMG_MAP[value] || null;
}

export function tileMeta(value) {
  return TILES[value] || TILES[8192];
}
